import { render, staticRenderFns } from "./DashboardVentasRanking.vue?vue&type=template&id=1dd5d9b1&scoped=true&lang=pug"
import script from "./DashboardVentasRanking.vue?vue&type=script&lang=js"
export * from "./DashboardVentasRanking.vue?vue&type=script&lang=js"
import style0 from "./DashboardVentasRanking.vue?vue&type=style&index=0&id=1dd5d9b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd5d9b1",
  null
  
)

export default component.exports